<template>
  <MatchMedia query="(max-width: 760px)" v-slot="{ matches }">
    <NicheShowMobile  v-if="matches" />
    <NicheShowDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import NicheShowMobile from "./NicheShow_Mobile.vue";
  import NicheShowDesktop from "./NicheShow_Desktop.vue";
 
  export default {
    name: 'Desktop',
    components: {
      MatchMedia,
      NicheShowMobile,
      NicheShowDesktop,
    },
  }
</script> 